import React, { createContext, useState } from "react";
export const SpeechReviewContext = createContext({});
const SpeechSwallowReviewFormProvider = ({ children }) => {
  const [formData, setFormData] = useState({});
  return (
    <SpeechReviewContext.Provider value={{ formData, setFormData }}>
      {children}
    </SpeechReviewContext.Provider>
  );
};

export default SpeechSwallowReviewFormProvider;
